// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__W_HKo","logo":"styles_logo__3FuOS"};